import React, { Component } from "react";
import { connect } from "react-redux";
import { Spin } from "antd";
import { Page } from "../../../helbest";
import IconChevronLeft from "../../../assets/images/icons/chevron_left_rv.png";
import { API } from "../../../request/api";
import Header from "../Cart/Header/Header";
import { LangLink } from "../../components/LangLink/LangLink";

class Home extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      loading: true,
    };
  }

  componentDidMount() {
    API.get
      .serviceCenterTypes(parseInt(this.props.Login.city_id))
      .then((response) => {
        if (response.success) {
          this.setState({ data: response.data, loading: false });
        } else {
          this.setState({ loading: false });
        }
      })
      .catch((error) => {
        this.setState({ loading: false });
        console.log("Error : ", error);
      });
  }

  render() {
    return (
      <Page
        className="page-sc"
        title="لیست مراکز ارائه خدمات"
        back={true}
        address="/"
        showFooter
        mobileContainer
        customHeader={<Header url={"/"} label={"HiG Centers"} />}
        headerFix
        logo
      >
        <div className="container desktop-mode">
          <ul className="home-list p-0 mt-3 red-line">
            {this.state.loading ? (
              <div className="text-center mt-5">
                <Spin size="large" className="red" />
              </div>
            ) : this.state.data.length < 1 ? (
              <h4 className="text-center   font-16 pt-3 gray-color-low">
                متاسفانه موردی یافت نشد.
              </h4>
            ) : (
              this.state.data.map((x, i) => (
                <LangLink key={i} to={`/service-center/list/${x.id}/`}>
                  <li className="page-sc-home-item animated fadeInUp">
                    {x.name}
                    <img
                      style={{
                        transform: "rotate(180deg)",
                      }}
                      className="hei-15"
                      src={IconChevronLeft}
                      alt="<"
                    />
                  </li>
                </LangLink>
              ))
            )}
          </ul>
        </div>
      </Page>
    );
  }
}
const mstp = (state) => ({
  Login: state.Login,
});
export default connect(mstp)(Home);
